

  // customdesignmsajax.js

  // ===== INITIALIZE MODULES =====
  // Canvas setup is handled by canvas-setup.js module
  window.CanvasModule.initializeCanvases();
  
  // Extract canvas references from modules
  var CANVAS_DISPLAY_SIZE = window.CanvasModule.CANVAS_DISPLAY_SIZE;
  var CANVAS_INTERNAL_SIZE = window.CanvasModule.CANVAS_INTERNAL_SIZE;
  var RESOLUTION_SCALE = window.CanvasModule.RESOLUTION_SCALE;
  
  var cvs_bg = window.CanvasModule.getCanvas('bg');
  var ctx_bg = window.CanvasModule.getContext('bg');
  var cvsH_bg = CANVAS_DISPLAY_SIZE;
  var cvsW_bg = CANVAS_DISPLAY_SIZE;
  
  var cvs_ts = window.CanvasModule.getCanvas('ts');
  var ctx_ts = window.CanvasModule.getContext('ts');
  
  var cvs_trans = window.CanvasModule.getCanvas('trans');
  var ctx_trans = window.CanvasModule.getContext('trans');
  var cvsH_trans = CANVAS_DISPLAY_SIZE;
  var cvsW_trans = CANVAS_DISPLAY_SIZE;
  
  var cvs_txt = window.CanvasModule.getCanvas('txt');
  
  // Upload assets tracking moved to image-upload.js

    var PARTS = (window.CUSTOMIZER_ASSETS && window.CUSTOMIZER_ASSETS.parts) || [
      {
        bg: "https://cdn.shopify.com/s/files/1/0965/8466/3359/files/Gemini_Generated_Image_ffncm7ffncm7ffncer_ade9d5b0-3362-474f-ad11-ada127b1c4c1.png?v=1765261676",
        trans: ""
      },
      {
        bg: "https://cdn.shopify.com/s/files/1/0965/8466/3359/files/Gemini_Generated_Image_9hthr9hthr9hthr9_036ccfd8-a15a-414b-b9ce-ed54e1534090.png?v=1765261676",
        trans: ""
      }
    ];
    window.PARTS = PARTS;  // Expose for modules (color-picker)

    // Print boxes from design-areas.js module
    var FRONT_BOX = window.DesignAreas.FRONT_BOX;
    var BACK_BOX = window.DesignAreas.BACK_BOX;
    var BACK_TOP = window.DesignAreas.BACK_TOP;
    var BACK_MIDDLE = window.DesignAreas.BACK_MIDDLE;
    var BACK_BOTTOM = window.DesignAreas.BACK_BOTTOM;
    var HOOD_LEFT_BOX = window.DesignAreas.HOOD_LEFT_BOX;
    var HOOD_RIGHT_BOX = window.DesignAreas.HOOD_RIGHT_BOX;

    // Zoom configurations from design-areas module
    var ZOOM_CONFIGS = window.DesignAreas.ZOOM_CONFIGS;
    var CURRENT_ZOOM = null;

    // Delegate zoom functions to design-areas module
    function applyCanvasZoom(zoomConfig, skipAnimation) {
      window.DesignAreas.applyCanvasZoom(zoomConfig, skipAnimation);
      CURRENT_ZOOM = window.DesignAreas.getCurrentZoom();
    }

    function maintainZoom() {
      window.DesignAreas.maintainZoom();
    }

    function switchCanvasMode(partIndex, box, buttonId, zoomKey) {
      window.DesignAreas.switchCanvasMode(partIndex, box, buttonId, zoomKey);
    }

    // Delegate box helper functions to design-areas module
    function getPadForBox(boxName, box) {
      return window.DesignAreas.getPadForBox(boxName, box);
    }

    function getCurrentBox() {
      return window.DesignAreas.getCurrentBox();
    }

    // ===== DESIGN LAYERS =====
    var cvs = window.CanvasModule.getCanvas('designs');
    var ctx = window.CanvasModule.getContext('designs');
    var cvsH = CANVAS_DISPLAY_SIZE;
    var cvsW = CANVAS_DISPLAY_SIZE;

    var isDown = false;
    var moveAble = false;
    var beginX, beginY;

    var cur_item;
    var cur_img;
    var cur_item_width, cur_item_height;
    var cur_scaleX = 1, cur_scaleY = 1;
    var cur_rotate_radian = 0;
    var snapGuides = { showX: false, showY: false, centerX: 0, centerY: 0, box: null };

    var Selected_Round_R = 3.5;
    var DESIGN_ITEMS = [];
    window.DESIGN_ITEMS = DESIGN_ITEMS;  // Expose for modules

    // ===== PRODUCT MODE (config-driven) =====
    window.ProductConfig.setActiveProductId("hoodie");
    var CUSTOMIZER_MODE = window.ProductConfig.getActiveProductId();
    window.CUSTOMIZER_MODE = CUSTOMIZER_MODE;
    var EXPANSION_DESIGN_ITEMS = [];
    window.EXPANSION_DESIGN_ITEMS = EXPANSION_DESIGN_ITEMS;
    var EXPANSION_PARTS = [];
    window.EXPANSION_PARTS = EXPANSION_PARTS;
    // Per-product edited items storage
    window.EXPANSION_EDITED_ITEMS = {};
    // Per-product teamwall text (independent from #back_middle_input)
    window.EXPANSION_TEAMWALL_TEXT = {};
    // Currently editing expansion product ID
    window.currentEditingExpansionId = null;
    var ACTIVE_ITEMS = DESIGN_ITEMS;
    window.ACTIVE_ITEMS = ACTIVE_ITEMS;
    var ACTIVE_PARTS = PARTS;

    var CURRENT_INDEX = 0;
    window.CURRENT_INDEX = 0;  // Expose for modules
    var d_item_sort = 0;

    var resizeStart = null;
    var currentHandleType = null;
    function setActiveMode(btnId) {
      var config = window.ProductConfig.getActiveProduct();
      $(config.uiConfig.modeButtonsSelector).removeClass("active-mode");
      $(btnId).addClass("active-mode");
    }
    window.setActiveMode = setActiveMode;  // Expose for modules
    
    // Cached placeholder icon SVG image
    var placeholderIconImg = null;
    var placeholderIconLoaded = false;
    
    function loadPlaceholderIcon() {
      if (placeholderIconLoaded) return;
      var svgString = '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.45 6V9H9V39H39V18.6H42V39C42 39.8 41.7 40.5 41.1 41.1C40.5 41.7 39.8 42 39 42H9C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.2 6.3 7.5 6.9 6.9C7.5 6.3 8.2 6 9 6H29.45ZM38 6V10.05H42.05V13.05H38V17.1H35V13.05H30.95V10.05H35V6H38ZM12 33.9H36L28.8 24.3L22.45 32.65L17.75 26.45L12 33.9Z" fill="#999999"/></svg>';
      var svgBlob = new Blob([svgString], {type: 'image/svg+xml;charset=utf-8'});
      var url = URL.createObjectURL(svgBlob);
      placeholderIconImg = new Image();
      placeholderIconImg.onload = function() {
        placeholderIconLoaded = true;
        URL.revokeObjectURL(url);
        // Trigger redraw after icon loads
        if (typeof DESIGN !== 'undefined' && typeof DESIGN.render === 'function') {
          DESIGN.render();
        }
      };
      placeholderIconImg.src = url;
    }
    
    // Load placeholder icon on initialization
    loadPlaceholderIcon();

    // Delegate highlight box management to design-areas module
    function setHighlightBox(box) {
      window.DesignAreas.setHighlightBox(box);
    }

    function clearHighlightBox() {
      window.DesignAreas.clearHighlightBox();
    }
    
    function getHighlightBox() {
      return window.DesignAreas.getHighlightBox();
    }

    // === Accordion helpers ===
    function collapseAllSections() {
      $(".section-content").slideUp(120);
      $(".section-btn").removeClass("expanded");
    }

    // changed: this always opens the requested section (no toggle)
    function expandSection(sectionBtnId) {
      var contentId = "#content_" + sectionBtnId.replace("sec_", "");
      // collapse others (no animation to avoid flicker)
      $(".section-content").not(contentId).stop(true, true).slideUp(0);
      $(".section-btn").not("#" + sectionBtnId).removeClass("expanded");
      // open requested
      if (!$(contentId).is(":visible")) {
        $(contentId).stop(true, true).slideDown(0);
      }
      $("#" + sectionBtnId).addClass("expanded");
    }

    // Delegate box functions to design-areas module
    function pointInBox(x, y, box) {
      return window.DesignAreas.pointInBox(x, y, box);
    }

    function boxHasContent(partIndex, boxName) {
      return window.DesignAreas.boxHasContent(partIndex, boxName);
    }

    // Team Wall functionality is handled by team-wall.js module


    // Delegate Team Wall selection to module
    function selectTeamWallItem(shouldSelect) {
      if (window.TeamWall && window.TeamWall.selectItem) {
        window.TeamWall.selectItem(shouldSelect);
      }
    }

    // Delegate Team Wall rendering to module
    function renderTeamWallText() {
      if (window.TeamWall && window.TeamWall.render) {
        window.TeamWall.render();
      }
    }

    // ===== FRONT/BACK LOADER =====
    function loadPart(index) {
      CURRENT_INDEX = index;
      window.CURRENT_INDEX = index;  // Update for modules

      // No longer switching between front/back - all sections visible
      if (index === 0) {
        // Front mode
      } else {

        // Trigger team wall update if there's text when switching to back (base product only)
        if (window.ProductConfig.isBaseProduct()) {
          var teamWallText = $("#back_middle_input").val();
          if (teamWallText && teamWallText.trim().length > 0) {
            // Use a small delay to ensure canvas is ready
            setTimeout(function() {
              renderTeamWallText();
            }, 100);
          }
        }
      }

      // Don't automatically open sections when loading parts
      // This was causing the wrong dropdown to open

      // Draw placeholder background if image fails to load
      function drawPlaceholderBackground() {
        ctx_bg.clearRect(0, 0, CANVAS_DISPLAY_SIZE, CANVAS_DISPLAY_SIZE);
        // Draw a simple hoodie outline placeholder
        ctx_bg.fillStyle = '#f0f0f0';
        ctx_bg.fillRect(0, 0, cvsW_bg, cvsH_bg);
        
        // Draw a simple hoodie shape
        ctx_bg.fillStyle = '#d0d0d0';
        ctx_bg.beginPath();
        if (index === 0) {
          // Front view placeholder
          if (ctx_bg.roundRect) {
            ctx_bg.roundRect(150, 120, 400, 450, 20);
          } else {
            ctx_bg.rect(150, 120, 400, 450);
          }
          ctx_bg.fill();
          // Hood area
          ctx_bg.beginPath();
          ctx_bg.arc(350, 150, 80, 0, Math.PI * 2);
          ctx_bg.fillStyle = '#c0c0c0';
          ctx_bg.fill();
        } else {
          // Back view placeholder
          if (ctx_bg.roundRect) {
            ctx_bg.roundRect(150, 120, 400, 450, 20);
          } else {
            ctx_bg.rect(150, 120, 400, 450);
          }
          ctx_bg.fill();
          // Hood area
          ctx_bg.fillStyle = '#c0c0c0';
          ctx_bg.fillRect(280, 80, 140, 80);
        }
      }

      // Use shared drawCentered from CanvasModule
      var drawCenteredOnCanvas = window.CanvasModule.drawCentered;

      // Clear bg synchronously so a stale layer (e.g. expansion bg lingering
      // when exiting back to hoodie) can't show through under newly-drawn
      // items between drawImages() and the async img_bg.onload below.
      ctx_bg.clearRect(0, 0, cvsW_bg, cvsH_bg);

      var img_bg = new Image();
      img_bg.crossOrigin = "anonymous";
      img_bg.src = ACTIVE_PARTS[index].bg;
      img_bg.onload = function () {
        ctx_bg.clearRect(0, 0, CANVAS_DISPLAY_SIZE, CANVAS_DISPLAY_SIZE);
        // Use aspect-ratio-preserving draw for non-square images (e.g. arm view)
        var imgW = img_bg.naturalWidth || img_bg.width;
        var imgH = img_bg.naturalHeight || img_bg.height;
        var isSquare = Math.abs(imgW / imgH - 1) < 0.05;
        if (isSquare) {
          ctx_bg.drawImage(img_bg, 0, 0, imgW, imgH, 0, 0, cvsW_bg, cvsH_bg);
        } else {
          drawCenteredOnCanvas(ctx_bg, img_bg, cvsW_bg, cvsH_bg);
        }
      };
      img_bg.onerror = function() {
        // Silently use placeholder when image is missing
        drawPlaceholderBackground();
      };

      ctx_trans.clearRect(0, 0, CANVAS_DISPLAY_SIZE, CANVAS_DISPLAY_SIZE);
      if (ACTIVE_PARTS[index].trans) {
        var img_trans = new Image();
        img_trans.crossOrigin = "anonymous";
        img_trans.src = ACTIVE_PARTS[index].trans;
        img_trans.onload = function () {
          var tImgW = img_trans.naturalWidth || img_trans.width;
          var tImgH = img_trans.naturalHeight || img_trans.height;
          var tIsSquare = Math.abs(tImgW / tImgH - 1) < 0.05;
          if (tIsSquare) {
            ctx_trans.drawImage(img_trans, 0, 0, tImgW, tImgH, 0, 0, cvsW_trans, cvsH_trans);
          } else {
            drawCenteredOnCanvas(ctx_trans, img_trans, cvsW_trans, cvsH_trans);
          }
          // Clear trans overlay pixels in clipped design areas so logos stay visible
          var activeId = window.ProductConfig.getActiveProductId();
          var clipBoxes = window.ProductConfig.getBoxesForPartIndex(activeId, index);
          for (var bName in clipBoxes) {
            if (clipBoxes[bName].clip) {
              ctx_trans.clearRect(clipBoxes[bName].x, clipBoxes[bName].y,
                                  clipBoxes[bName].width, clipBoxes[bName].height);
            }
          }
        };
        img_trans.onerror = function() {
          // Silently clear the transparency layer when mask is missing
          ctx_trans.clearRect(0, 0, CANVAS_DISPLAY_SIZE, CANVAS_DISPLAY_SIZE);
        };
      }
      DESIGN.drawImages();
    }
    window.loadPart = loadPart;  // Expose for modules

    // ===== IMAGE LIST UI =====
    function AddImage(img, el_id) {
      // Image list UI removed — items tracked in DESIGN_ITEMS only
    }

    // ===== DESIGN OBJECT =====
    // Define DESIGN object with all core editing functionality
    var DESIGN = {
      initDesign: function () {
        DESIGN.wireInteractionEvents();
      },

      initImgToBox: function (img, el_id, box, partIndex, boxName, skipSelection) {
        if (cur_item != null) cur_item.selected = false;
        var imgItem = {};
        imgItem.flag = 1;
        imgItem.img = img;
        imgItem.img_id = 0;
        imgItem.width = img.width;
        imgItem.height = img.height;
        imgItem.rotate = 0;
        // Allow optional skipSelection parameter
        imgItem.selected = skipSelection ? false : true;
        imgItem.el_id = el_id;
        imgItem.show = true;
        imgItem.part_index = partIndex;

        var pad = (boxName === "back_bottom") ? 0 : getPadForBox(boxName || "", box);
        var availW = Math.max(box.width - pad * 2, 1);
        var availH = Math.max(box.height - pad * 2, 1);
        var sx = availW / img.width;
        var sy = availH / img.height;
        var s = Math.min(sx, sy);
        imgItem.scaleX = s;
        imgItem.scaleY = s;

        imgItem.PO = {
          x: box.x + box.width / 2,
          y: box.y + box.height / 2
        };

        imgItem.boxName = boxName || null;
        imgItem.box = boxName || null;  // Also set box property for compatibility

        ACTIVE_ITEMS.push(imgItem);
        // Only set as current item if not skipping selection
        if (!skipSelection) {
          cur_item = imgItem;
        window.cur_item = cur_item;  // Sync with Team Wall module
        }
        DESIGN.drawImages();
      },



      drawBoxOutline: function (box) {
        ctx.save();
        ctx.strokeStyle = "#aaaaaa";
        ctx.lineWidth = 1;
        ctx.setLineDash([5, 5]); // 5px dash, 5px gap
        ctx.strokeRect(box.x, box.y, box.width, box.height);
        ctx.restore();
      },

      drawPlaceholder: function (box, mainText, subText) {
        ctx.save();

        var cx = box.x + box.width / 2;
        var cy = box.y + box.height / 2;

        var radius = Math.min(box.width, box.height) * 0.40;
        ctx.beginPath();
        ctx.fillStyle = "#f2f2f2";
        ctx.arc(cx, cy, radius, 0, Math.PI * 2);
        ctx.fill();

        // Draw SVG icon instead of simple square+plus
        var iconSize = radius * 0.8;
        var ix = cx - iconSize / 2;
        // center icon vertically in the circle
        var iy = cy - iconSize / 2;
        
        // Draw cached placeholder icon if loaded
        if (placeholderIconLoaded && placeholderIconImg) {
          ctx.drawImage(placeholderIconImg, ix, iy, iconSize, iconSize);
        } else {
          // Fallback: draw simple icon if SVG not loaded yet
          ctx.strokeStyle = "#999999";
          ctx.lineWidth = 1.5;
          ctx.strokeRect(ix, iy, iconSize, iconSize);
          ctx.beginPath();
          ctx.moveTo(ix + iconSize * 0.72, iy - iconSize * 0.15);
          ctx.lineTo(ix + iconSize * 0.92, iy - iconSize * 0.15);
          ctx.moveTo(ix + iconSize * 0.82, iy - iconSize * 0.25);
          ctx.lineTo(ix + iconSize * 0.82, iy - iconSize * 0.05);
          ctx.stroke();
        }

        var mainFontSize = "10px";
        var subFontSize = "9px";
        var mainY = cy + radius * 0.4;
        var subY = mainY + 11;

        ctx.textAlign = "center";
        ctx.textBaseline = "top";

        ctx.fillStyle = "#000";
        ctx.font = "bold " + mainFontSize + " Arial";
        ctx.fillText(mainText, cx, mainY);

        ctx.fillStyle = "#555";
        ctx.font = subFontSize + " Arial";
        ctx.fillText(subText, cx, subY);

        ctx.restore();
      },

      handlePlaceholderClick: function (x, y) {
        if (!window.ProductConfig.isBaseProduct()) return false;
        if (CURRENT_INDEX === 0) {
          if (pointInBox(x, y, FRONT_BOX) && !boxHasContent(0, "front")) {
            document.getElementById("input_front_logo").click();
            return true;
          }
        } else {
          if (pointInBox(x, y, BACK_TOP) && !boxHasContent(1, "back_top")) {
            document.getElementById("input_back_top_logo").click();
            return true;
          }
          if (pointInBox(x, y, BACK_MIDDLE) && !boxHasContent(1, "back_middle")) {
            document.getElementById("back_middle_input").focus();
            return true;
          }
          if (pointInBox(x, y, BACK_BOTTOM) && !boxHasContent(1, "back_bottom")) {
            return true;
          }
          if (HOOD_LEFT_BOX && pointInBox(x, y, HOOD_LEFT_BOX) && !boxHasContent(1, "hood_left")) {
            if (window.ImageUpload && window.ImageUpload.getHoodLeftMode() === "text") {
              var hoodLeftInput = document.getElementById("hood_left_text_input");
              if (hoodLeftInput) hoodLeftInput.focus();
            } else {
              document.getElementById("input_hood_left_logo").click();
            }
            return true;
          }
          if (HOOD_RIGHT_BOX && pointInBox(x, y, HOOD_RIGHT_BOX) && !boxHasContent(1, "hood_right")) {
            if (window.ImageUpload && window.ImageUpload.getHoodRightMode() === "text") {
              var hoodRightInput = document.getElementById("hood_right_text_input");
              if (hoodRightInput) hoodRightInput.focus();
            } else {
              document.getElementById("input_hood_right_logo").click();
            }
            return true;
          }
        }
        return false;
      },

      // ---------- MAIN DRAW ----------
      drawImages: function () {
        // Start every frame from the canvas's base transform. A draw that threw
        // between save() and restore() used to leave its item's translate on the
        // context for good, so every later frame drew designs off the canvas and
        // the clear missed the old box outlines (KG jenter zip hoodie, 2026-10-02:
        // two throws on restore left matrix(2,0,0,2,1748,1040), an empty front
        // and the front-chest box drawn over the arm).
        ctx.setTransform(RESOLUTION_SCALE, 0, 0, RESOLUTION_SCALE, 0, 0);
        ctx_ts.setTransform(RESOLUTION_SCALE, 0, 0, RESOLUTION_SCALE, 0, 0);
        ctx.clearRect(0, 0, cvsW, cvsH);
        ctx_ts.clearRect(0, 0, CANVAS_DISPLAY_SIZE, CANVAS_DISPLAY_SIZE);

        // Draw box outlines and placeholders based on active product config
        var activeId = window.ProductConfig.getActiveProductId();
        var boxesForView = window.ProductConfig.getBoxesForPartIndex(activeId, CURRENT_INDEX);

        if (window.ProductConfig.isBaseProduct()) {
          // Base product: draw highlight overlay, box outlines, and placeholders
          var highlightBox = getHighlightBox();
          if (highlightBox) {
            var showHighlight = true;
            // Don't show highlight on boxes that already have content
            for (var hbName in boxesForView) {
              if (boxesForView[hbName] === highlightBox && boxHasContent(boxesForView[hbName].partIndex, hbName)) {
                showHighlight = false;
                break;
              }
            }

            if (showHighlight) {
              ctx_ts.save();
              ctx_ts.fillStyle = "rgba(0,0,0,0.08)";
              ctx_ts.fillRect(highlightBox.x, highlightBox.y, highlightBox.width, highlightBox.height);
              ctx_ts.lineWidth = 2;
              ctx_ts.strokeStyle = "#000000";
              ctx_ts.strokeRect(highlightBox.x + 1, highlightBox.y + 1, highlightBox.width - 2, highlightBox.height - 2);
              ctx_ts.restore();
            }
          }

          var activeConfig = window.ProductConfig.getActiveProduct();
          for (var bxName in boxesForView) {
            DESIGN.drawBoxOutline(boxesForView[bxName]);
            // Draw placeholders for empty boxes
            if (!boxHasContent(boxesForView[bxName].partIndex, bxName)) {
              var ph = activeConfig.placeholders && activeConfig.placeholders[bxName];
              if (ph && ph.type === "image") {
                DESIGN.drawPlaceholder(boxesForView[bxName], bxName === "front" ? "Upload Image" : "", "");
              } else if (ph && ph.type === "text" && bxName === "back_middle") {
                var teamWallText = $("#back_middle_input").val() || "";
                if (teamWallText.trim().length === 0) {
                  ctx_ts.save();
                  ctx_ts.strokeStyle = "#aaaaaa";
                  ctx_ts.lineWidth = 1;
                  ctx_ts.setLineDash([5, 5]);
                  ctx_ts.strokeRect(boxesForView[bxName].x, boxesForView[bxName].y, boxesForView[bxName].width, boxesForView[bxName].height);
                  ctx_ts.restore();
                }
              }
            }
          }
        } else {
          // Expansion product: draw box outlines only (no placeholders)
          for (var boxName in boxesForView) {
            DESIGN.drawBoxOutline(boxesForView[boxName]);
          }
        }

        for (var j = 0; j < ACTIVE_ITEMS.length; j++) {
          var item = ACTIVE_ITEMS[j];
          if (!item.show || item.part_index !== CURRENT_INDEX) continue;
          // A restored item can arrive before its img is an image element (a
          // plain {src} from the manifest); drawImage throws on that. It is
          // drawn on the frame after its image loads.
          if (!(item.img instanceof HTMLImageElement || item.img instanceof HTMLCanvasElement ||
                (typeof ImageBitmap !== "undefined" && item.img instanceof ImageBitmap))) continue;

          var clipBox = null;
          var boxDef = window.ProductConfig.getBoxByName(
            window.ProductConfig.getActiveProductId(), item.boxName
          );
          if (boxDef && boxDef.clip) {
            clipBox = boxDef;
          }

          ctx.save();
          if (clipBox) {
            ctx.beginPath();
            ctx.rect(clipBox.x, clipBox.y, clipBox.width, clipBox.height);
            ctx.clip();
          }

          ctx.translate(item.PO.x, item.PO.y);
          cur_img = item.img;
          cur_item_width = item.width;
          cur_item_height = item.height;
          cur_scaleX = item.scaleX;
          cur_scaleY = item.scaleY;
          // Clamped through the same helper as the export, so the canvas shows
          // what the print will be. A design saved before the hood rule existed
          // still carries its rotate; without this the screen would tilt the
          // badge and canvas-exporter.js would straighten it, which is a
          // preview lying about the garment. Also feeds the selection box and
          // the hit-testing below, so the handles sit on the drawn shape.
          cur_rotate_radian = window.DesignHelpers.drawRotation(item);
          ctx.rotate(cur_rotate_radian);

          if (item.selected) {
            ctx_ts.save();
            ctx_ts.translate(item.PO.x, item.PO.y);
            ctx_ts.rotate(cur_rotate_radian);
            // Draw clean black border with subtle shadow
            ctx_ts.save();
            ctx_ts.shadowColor = "rgba(0, 0, 0, 0.15)";
            ctx_ts.shadowBlur = 2;
            ctx_ts.shadowOffsetX = 0;
            ctx_ts.shadowOffsetY = 1;
            ctx_ts.strokeStyle = "#000000";
            ctx_ts.lineWidth = 0.75;
            ctx_ts.strokeRect(
              (-cur_item_width * cur_scaleX) / 2,
              (-cur_item_height * cur_scaleY) / 2,
              cur_item_width * cur_scaleX,
              cur_item_height * cur_scaleY
            );
            ctx_ts.restore();
            DESIGN.drawHandles();
            ctx_ts.restore();
          }

          ctx.drawImage(
            cur_img,
            0, 0, cur_item_width, cur_item_height,
            (-cur_item_width * cur_scaleX) / 2,
            (-cur_item_height * cur_scaleY) / 2,
            cur_item_width * cur_scaleX,
            cur_item_height * cur_scaleY
          );
          ctx.restore();
        }
        
        // Draw snap guides if active
        if (snapGuides.box && (snapGuides.showX || snapGuides.showY)) {
          ctx_ts.save();
          ctx_ts.setLineDash([5, 5]);  // Dotted line pattern
          ctx_ts.strokeStyle = "#000000";
          ctx_ts.lineWidth = 1;
          ctx_ts.globalAlpha = 0.5;
          
          if (snapGuides.showX) {
            // Draw vertical center line
            ctx_ts.beginPath();
            ctx_ts.moveTo(snapGuides.centerX, snapGuides.box.y);
            ctx_ts.lineTo(snapGuides.centerX, snapGuides.box.y + snapGuides.box.height);
            ctx_ts.stroke();
          }
          
          if (snapGuides.showY) {
            // Draw horizontal center line
            ctx_ts.beginPath();
            ctx_ts.moveTo(snapGuides.box.x, snapGuides.centerY);
            ctx_ts.lineTo(snapGuides.box.x + snapGuides.box.width, snapGuides.centerY);
            ctx_ts.stroke();
          }
          
          ctx_ts.restore();
        }
        
        // Maintain zoom state after redrawing
        maintainZoom();
      }
    };

    // Install canvas interaction methods from canvas-interaction.js
    (function() {
        var S = {};
        var props = {
            isDown: function() { return isDown; }, setIsDown: function(v) { isDown = v; },
            moveAble: function() { return moveAble; }, setMoveAble: function(v) { moveAble = v; },
            beginX: function() { return beginX; }, setBeginX: function(v) { beginX = v; },
            beginY: function() { return beginY; }, setBeginY: function(v) { beginY = v; },
            cur_item: function() { return cur_item; }, setCur_item: function(v) { cur_item = v; },
            cur_img: function() { return cur_img; }, setCur_img: function(v) { cur_img = v; },
            cur_item_width: function() { return cur_item_width; }, setCur_item_width: function(v) { cur_item_width = v; },
            cur_item_height: function() { return cur_item_height; }, setCur_item_height: function(v) { cur_item_height = v; },
            cur_scaleX: function() { return cur_scaleX; }, setCur_scaleX: function(v) { cur_scaleX = v; },
            cur_scaleY: function() { return cur_scaleY; }, setCur_scaleY: function(v) { cur_scaleY = v; },
            cur_rotate_radian: function() { return cur_rotate_radian; }, setCur_rotate_radian: function(v) { cur_rotate_radian = v; },
            snapGuides: function() { return snapGuides; }, setSnapGuides: function(v) { snapGuides = v; },
            Selected_Round_R: function() { return Selected_Round_R; }, setSelected_Round_R: function(v) { Selected_Round_R = v; },
            resizeStart: function() { return resizeStart; }, setResizeStart: function(v) { resizeStart = v; },
            currentHandleType: function() { return currentHandleType; }, setCurrentHandleType: function(v) { currentHandleType = v; },
            ACTIVE_ITEMS: function() { return ACTIVE_ITEMS; }, setACTIVE_ITEMS: function(v) { ACTIVE_ITEMS = v; },
            CURRENT_INDEX: function() { return CURRENT_INDEX; }, setCURRENT_INDEX: function(v) { CURRENT_INDEX = v; },
            DESIGN_ITEMS: function() { return DESIGN_ITEMS; }, setDESIGN_ITEMS: function(v) { DESIGN_ITEMS = v; },
            d_item_sort: function() { return d_item_sort; }, setD_item_sort: function(v) { d_item_sort = v; },
            ctx: function() { return ctx; },
            ctx_ts: function() { return ctx_ts; },
            cvs: function() { return cvs; },
            cvs_ts: function() { return cvs_ts; },
            cvsW: function() { return cvsW; },
            cvsH: function() { return cvsH; },
            CURRENT_ZOOM: function() { return CURRENT_ZOOM; },
            CANVAS_DISPLAY_SIZE: function() { return CANVAS_DISPLAY_SIZE; },
            FRONT_BOX: function() { return FRONT_BOX; },
            BACK_TOP: function() { return BACK_TOP; },
            BACK_MIDDLE: function() { return BACK_MIDDLE; },
            BACK_BOTTOM: function() { return BACK_BOTTOM; },
            HOOD_LEFT_BOX: function() { return HOOD_LEFT_BOX; },
            HOOD_RIGHT_BOX: function() { return HOOD_RIGHT_BOX; }
        };
        // Build S with getter/setters for mutable state
        ['isDown','moveAble','beginX','beginY','cur_item','cur_img','cur_item_width','cur_item_height','cur_scaleX','cur_scaleY','cur_rotate_radian','snapGuides','Selected_Round_R','resizeStart','currentHandleType','ACTIVE_ITEMS','CURRENT_INDEX','DESIGN_ITEMS','d_item_sort'].forEach(function(key) {
            var capKey = 'set' + key.charAt(0).toUpperCase() + key.slice(1);
            Object.defineProperty(S, key, {
                get: props[key],
                set: props[capKey]
            });
        });
        // Read-only refs
        ['ctx','ctx_ts','cvs','cvs_ts','cvsW','cvsH','CURRENT_ZOOM','CANVAS_DISPLAY_SIZE','FRONT_BOX','BACK_TOP','BACK_MIDDLE','BACK_BOTTOM','HOOD_LEFT_BOX','HOOD_RIGHT_BOX'].forEach(function(key) {
            Object.defineProperty(S, key, { get: props[key] });
        });
        window.installCanvasInteraction(DESIGN, S);
    })();


    // Export functions moved to canvas-exporter.js
    // Access via window.CanvasExporter or window.exportSideImageSilent / window.exportAllVariantImages

    // Valid image types moved to image-upload.js

    // Image upload and preview functions moved to image-upload.js
    // Access via window.ImageUpload

    // Expansion mode functions moved to expansion-mode.js
    // Access via window.ExpansionMode or window.enterExpansionEditMode / window.exitExpansionEditMode

    // ===== INIT EVERYTHING =====
    $(function () {
      DESIGN.initDesign();

      // initial show front settings: expand front section
      collapseAllSections();
      expandSection("sec_front_logo");
    setActiveMode("#btn_mode_front_logo");
      loadPart(0);
      // All sections visible from start
    setHighlightBox(FRONT_BOX);
      // Initialize image upload module
      if (window.ImageUpload && window.ImageUpload.initialize) {
        window.ImageUpload.initialize();
      }

      // Build zip hoodie zoom configs from ProductConfig
      var zipZoomRaw = window.ProductConfig.getZoomConfigs("zip_hoodie", window.DesignAreas.getZoomConfig);
      if (zipZoomRaw) {
        // Prefix keys with "zip_" for switchCanvasMode compatibility
        window.ZIP_ZOOM_CONFIGS = { reset: zipZoomRaw.reset };
        for (var zKey in zipZoomRaw) {
          if (zKey !== "reset") {
            window.ZIP_ZOOM_CONFIGS["zip_" + zKey] = zipZoomRaw[zKey];
          }
        }
      }

      // Section accordion with canvas focus
      $('.section-btn').off('click').on('click', function (e) {
        e.preventDefault();
        var id = $(this).attr('id');
        var contentId = '#content_' + id.replace('sec_', '');
        var $this = $(this);
        var isOpen = $this.hasClass('expanded');
        
        // Hide all sections first
        $('.section-content').hide();
        $('.section-btn').removeClass('expanded');
        
        // Toggle the clicked section
        if (!isOpen) {
          $(contentId).show();
          $this.addClass('expanded');
          
          // Switch canvas view and apply zoom when opening
          setTimeout(function() {
            var modeMap = {
              'sec_front_logo': [0, FRONT_BOX, "#btn_mode_front_logo", 'front'],
              'sec_hood_left_logo': [1, HOOD_LEFT_BOX, "#btn_mode_hood_left_logo", 'hood_left'],
              'sec_hood_right_logo': [1, HOOD_RIGHT_BOX, "#btn_mode_hood_right_logo", 'hood_right'],
              'sec_back_logo': [1, BACK_TOP, "#btn_mode_back_logo", 'back'],
              'sec_team_wall': [1, BACK_MIDDLE, "#btn_mode_team_wall", 'teamwall']
            };
            // The two optional sleeve badges. Read off ProductConfig rather than
            // spelled out, because their boxes live on their own views (parts 2
            // and 3) and the box IS the zoom key, so one lookup answers all four
            // arguments. Absent from the literal above so a hoodie without the
            // boxes — an older ALL_PRODUCTS, a cached asset — degrades to no
            // section rather than to a crash.
            ["left_sleeve", "right_sleeve"].forEach(function(boxName) {
              var b = window.ProductConfig.getBoxByName("hoodie", boxName);
              if (b) modeMap["sec_" + boxName] = [b.partIndex, b, "#btn_mode_" + boxName, boxName];
            });
            
            if (modeMap[id]) {
              switchCanvasMode(...modeMap[id]);
            }
          }, 50);
        } else {
          // Reset zoom when closing a section
          if (window.CanvasModule) {
            window.CanvasModule.zoom.resetZoom();
          } else {
            applyCanvasZoom(ZOOM_CONFIGS.reset);
          }
          clearHighlightBox();
        }
      });

      // highlight mode buttons only
      $(".mode-buttons button").on("click", function () {
        $(".mode-buttons button").removeClass("active-mode");
        $(this).addClass("active-mode");
      });

      // Mode button handlers - simplified
      var modeButtons = {
        "#btn_mode_front_logo": ["sec_front_logo", 0, FRONT_BOX, 'front'],
        "#btn_mode_hood_left_logo": ["sec_hood_left_logo", 1, HOOD_LEFT_BOX, 'hood_left'],
        "#btn_mode_hood_right_logo": ["sec_hood_right_logo", 1, HOOD_RIGHT_BOX, 'hood_right'],
        "#btn_mode_back_logo": ["sec_back_logo", 1, BACK_TOP, 'back'],
        "#btn_mode_team_wall": ["sec_team_wall", 1, BACK_MIDDLE, 'teamwall']
      };
      ["left_sleeve", "right_sleeve"].forEach(function(boxName) {
        var b = window.ProductConfig.getBoxByName("hoodie", boxName);
        if (b) modeButtons["#btn_mode_" + boxName] = ["sec_" + boxName, b.partIndex, b, boxName];
      });

      Object.keys(modeButtons).forEach(function(btnId) {
        $(btnId).on("click", function() {
          $(".mode-buttons button").removeClass("active-mode");
          $(this).addClass("active-mode");

          var [sectionId, partIndex, box, zoomKey] = modeButtons[btnId];
          expandSection(sectionId);
          switchCanvasMode(partIndex, box, btnId, zoomKey);
        });
      });

      // Canvas mousedown handler for auto-opening sections and highlight management
      $(".createImage").on("mousedown", function (e) {
        // Use DESIGN.getEvtLoc for proper coordinate transformation when zoomed
        var coords = DESIGN.getEvtLoc(e);
        var clickX = coords.x;
        var clickY = coords.y;

        // Wait for DESIGN.startMove() to complete item selection
        setTimeout(function() {
          // === EXPANSION PRODUCT MODE: handle canvas clicks ===
          if (window.ProductConfig.isExpansionProduct()) {
            if (!cur_item) return;
            var expId = window.currentEditingExpansionId;
            var expCfg = expId && window.ProductConfig.getProduct(expId);
            if (expCfg && cur_item.boxName) {
              var boxName = cur_item.boxName;
              var boxConfig = expCfg.boxes[boxName];
              if (boxConfig) {
                // Expand corresponding expansion section
                var sectionId = "sec_exp_" + boxName;
                var contentId = "#content_exp_" + boxName;
                $(".section-content-exp").not(contentId).stop(true, true).slideUp(0);
                $(".section-btn-exp").not("#" + sectionId).removeClass("expanded");
                if (!$(contentId).is(":visible")) {
                  $(contentId).stop(true, true).slideDown(0);
                }
                $("#" + sectionId).addClass("expanded");
                setHighlightBox(boxConfig);
                // Zoom to the clicked design's area (hood pair zooms as one region)
                applyCanvasZoom(window.DesignAreas.getBoxZoomConfig(expCfg, boxName));
                // Update mode buttons
                $("#expansion-dynamic-mode-buttons button").removeClass("active-mode");
                $("#expansion-dynamic-mode-buttons button[data-box='" + boxName + "']").addClass("active-mode");
              }
            }
            return;
          }

          // Check if clicking on team wall area (prioritize this even if an item is selected elsewhere)
          var clickedOnTeamWall = CURRENT_INDEX === 1 &&
              pointInBox(clickX, clickY, BACK_MIDDLE) &&
              !pointInBox(clickX, clickY, BACK_TOP) &&
              !(HOOD_LEFT_BOX && pointInBox(clickX, clickY, HOOD_LEFT_BOX)) &&
              !(HOOD_RIGHT_BOX && pointInBox(clickX, clickY, HOOD_RIGHT_BOX));

          // If clicking on team wall and current item is NOT in team wall, switch to team wall
          if (clickedOnTeamWall && (!cur_item || cur_item.boxName !== "back_middle")) {
            // Deselect current item if it's not in team wall
            if (cur_item) {
              cur_item = null;
              DESIGN.drawImages();
            }
            switchCanvasMode(1, BACK_MIDDLE, "#btn_mode_team_wall", "teamwall");
            expandSection("sec_team_wall");
            setTimeout(function () {
              $("#back_middle_input").focus();
            }, 160);
            return;
          }

          // If an item was selected, ensure correct view is active
          if (cur_item) {
            var viewConfig = {
              "front": ["sec_front_logo", FRONT_BOX, "#btn_mode_front_logo", "front"],
              "hood_left": ["sec_hood_left_logo", HOOD_LEFT_BOX, "#btn_mode_hood_left_logo", "hood_left"],
              "hood_right": ["sec_hood_right_logo", HOOD_RIGHT_BOX, "#btn_mode_hood_right_logo", "hood_right"],
              "back_top": ["sec_back_logo", BACK_TOP, "#btn_mode_back_logo", "back"],
              "back_middle": ["sec_team_wall", BACK_MIDDLE, "#btn_mode_team_wall", "teamwall"]
            };

            var config = viewConfig[cur_item.boxName];
            if (config) {
              expandSection(config[0]);
              setHighlightBox(config[1]);
              setActiveMode(config[2]);
              applyCanvasZoom(ZOOM_CONFIGS[config[3]]);
            }
            return;
          }
        }, 10);

        // Clear highlight if clicking outside the highlighted box
        // Add a buffer zone around the highlight box to account for resize handles
        var highlightBox = getHighlightBox();
        if (!highlightBox) return;
        
        // Add 30px buffer around the highlight box for handle tolerance
        var buffer = 30;
        var expandedBox = {
          x: highlightBox.x - buffer,
          y: highlightBox.y - buffer,
          width: highlightBox.width + (buffer * 2),
          height: highlightBox.height + (buffer * 2)
        };
        
        if (!(clickX >= expandedBox.x && clickX <= expandedBox.x + expandedBox.width &&
              clickY >= expandedBox.y && clickY <= expandedBox.y + expandedBox.height)) {
          clearHighlightBox();
          if (window.CanvasModule) {
            window.CanvasModule.zoom.resetZoom();
            CURRENT_ZOOM = null;
          } else {
            CURRENT_ZOOM = null;
            applyCanvasZoom(ZOOM_CONFIGS.reset);
          }
        }
      });


      // Remove button handlers moved to image-upload.js

      // Real-time text input handler with debouncing for team wall
      // Initialize Team Wall module
      if (window.TeamWall && window.TeamWall.init) {
        window.TeamWall.init();
      }



    });

    // ===== STATE BRIDGE FOR EXTRACTED MODULES =====
    // Provides getters/setters so expansion-mode.js and customizer-ui.js
    // can interact with closure-scoped state in this file.
    window.DESIGN.state = {
      setActiveItems: function(items) { ACTIVE_ITEMS = items; window.ACTIVE_ITEMS = items; },
      setActiveParts: function(parts) { ACTIVE_PARTS = parts; },
      setCustomizerMode: function(mode) { CUSTOMIZER_MODE = mode; window.CUSTOMIZER_MODE = mode; },
      setCurItem: function(item) { cur_item = item; window.cur_item = item; },
      setExpansionDesignItems: function(items) { EXPANSION_DESIGN_ITEMS = items; window.EXPANSION_DESIGN_ITEMS = items; },
      setExpansionParts: function(parts) { EXPANSION_PARTS = parts; window.EXPANSION_PARTS = parts; },
      setDesignItems: function(items) { DESIGN_ITEMS = items; window.DESIGN_ITEMS = items; },
      getDesignItems: function() { return DESIGN_ITEMS; },
      getParts: function() { return PARTS; },
      getActiveItems: function() { return ACTIVE_ITEMS; },
      getCurItem: function() { return cur_item; },
      getExpansionDesignItems: function() { return EXPANSION_DESIGN_ITEMS; }
    };

    // Expose globals for Team Wall module
    window.AddImage = AddImage;
    window.expandSection = expandSection;
    window.BACK_MIDDLE = BACK_MIDDLE;
    window.RESOLUTION_SCALE = RESOLUTION_SCALE;
    window.d_item_sort = d_item_sort;
    window.cur_item = cur_item;
    window.applyCanvasZoom = applyCanvasZoom;
    window.clearHighlightBox = clearHighlightBox;
    window.ZOOM_CONFIGS = ZOOM_CONFIGS;

// Customizer UI moved to customizer-ui.js